import { createAction, createAsyncAction } from "typesafe-actions";

const PREFIX = "@@si/ai-agent/download-pdf";

export const downloadPdf = createAsyncAction(`${PREFIX}/request`, `${PREFIX}/success`, `${PREFIX}/failure`)<
    { messageId: string },
    { messageId: string },
    { messageId: string; error: unknown }
>();

export const openRedirectModal = createAction(`${PREFIX}/open-redirect-modal`)<string>();

export const closeRedirectModal = createAction(`${PREFIX}/close-redirect-modal`)();
